import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { SettingsProvider } from './settings.service';
import { map } from 'rxjs/operators';
import {
    NotificationModel,
    NotificationModelEnum,
    NotificationConfigModel,
} from '../models/notification.models';
import { HttpParams } from '@angular/common/http';
import { FilterOutputModel, TableResponseQuery } from '../models';
import { FiltersService } from './filters.service';
import { TableHelperService } from 'app/shared/tables/table-helper.service';
import {GeneralService} from './general.service';

@Injectable()
export class NotificationDataService {
    alerts: BehaviorSubject<{
        items: NotificationModel[];
        length: number;
    }> = new BehaviorSubject({
        items: [],
        length: 0,
    });

    constructor(
        private http: HttpService,
        private tableHelperService: TableHelperService,
        private settingsService: SettingsProvider,
        private filterService: FiltersService,
        private generalService: GeneralService
    ) {}

    public saveNotifications(notif: NotificationModel[], length: number): void {
        this.alerts.next({ items: notif, length: length });
    }

    public fetchUnreadNotification(): Observable<any> {
        return this.fetchData(5, 0, '', 'UNREAD', []);
    }

    public getNotifications(): Observable<any> {
        return this.alerts.asObservable();
    }

    public fetchData(
        top: number,
        skip: number = 0,
        sortBy: string = '',
        filter: string = '',
        selectFilters: FilterOutputModel[]
    ): Observable<TableResponseQuery> {
        const url = `${this.settingsService.configuration.url}${env.NotificationDataService.apiUrlGetNotification}`;

        let params = new HttpParams();
        params = params.set('$count', 'true');
        params = top ? params.set('$top', top.toString()) : params;
        params = skip ? params.set('$skip', skip.toString()) : params;
        params = sortBy ? params.set('$orderby', sortBy.toString()) : params;

        // params = filter ? params.set('$filter', filter) : params;

        // logic to set filter values
        if (filter || (selectFilters && !!selectFilters.length)) {
            const mainFilterString = this.filterService.setFilters(
                filter,
                selectFilters,
                this.tableHelperService.buildSearchUrl(
                    filter,
                    NotificationModel.tableInfo().columns
                ),
                this.filterService.setSelectFiltersForList(
                    selectFilters,
                    NotificationModel.tableInfo().columns
                )
            );
            params = params.set('$filter', mainFilterString);
        }

        return this.http.getWithParams(url, params).pipe(
            map((response) => {
                const items = this.generalService.toUpperCamelCaseObj(response.body.items);

                return {
                    value: items.map((not) => {
                        return {
                            ...not,
                            Area: NotificationModelEnum[not.Area],
                        };
                    }),
                    count: response.body.count,
                };
            }),
            map((response) => {
                return new TableResponseQuery(response.value, response.count);
            })
        );
    }

    public setAsRead(form: any): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.NotificationDataService.apiUrlSetAsRead}`;
        return this.http.post(url, form);
    }

    public fetchNotificationConfig(): Observable<NotificationConfigModel[]> {
        const url = `${this.settingsService.configuration.url}${env.NotificationDataService.apiUrlConfigRead}`;
        return this.http.get(url).pipe(map((response) => this.generalService.toUpperCamelCaseObj(response.items)));
    }

    public enableNotification(obj): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.NotificationDataService.apiUrlConfigSetEnable}`;
        return this.http.post(url, obj);
    }

    public disableNotification(obj): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.NotificationDataService.apiUrlConfigSetDisable}`;
        return this.http.post(url, obj);
    }

    public saveNotificationsSettings(notificationSettings: NotificationConfigModel[]) {
        const url = `${this.settingsService.configuration.url}${env.NotificationDataService.apiUrlSetAsEnabled}`;

        return this.http.post(url, { notificationTypes: notificationSettings.filter(x => x.IsEnabled).map(x => x.NotificationType)});
    }
}
